import { createClient } from "@/v2/graphql/client"
import type { Response, Source } from "."

// Comboboxes are reachable from unauthenticated pages, so they talk to the
// guest endpoint rather than the app one.
const guest = createClient("/guest/graphql")

export default class implements Source {
  private readonly document: string

  constructor(document: string) {
    this.document = document
  }

  async fetch(query: string, field: string): Promise<Response> {
    if (query.length === 0) {
      return { data: { results: [] } }
    }

    return {
      data: await guest<Record<string, unknown>>(this.document, {
        query,
        field,
      }),
    }
  }
}
